import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewBajaCabeza = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'baja_cabeza_rfid',
        name: 'Egreso hacienda RFID',
        component: ViewBajaCabeza,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'baja_cabeza',
        name: 'Egreso hacienda...',
        component: ViewBajaCabeza,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
